export default "__VITE_ASSET__D$fXAcND__"